<template>
<div>
  <div id="active-page" :class="{'page-fade': !mountedPage}"></div>
  <h1>{{$t('titles.preview')}}</h1>
  <div class="content-preview" v-if="getImages.length > 0">
    <v-container fluid>
    <v-layout row wrap>
      <!-- <itt-img-miniature-prev :imgFile="image"></itt-img-miniature-prev> -->
      <img-and-select
        v-for="(image, index) in getMedias"
        :key="index"
        class="sm6 md2"
        @delete="deleteImg" 
        :element="image"
        :deletable="true"
      />
      </v-layout>
    </v-container>
  </div>
  <div class="double-buttons">
    <a @click="cancelImg">
      <itt-arrow-btn :text="$t('buttons.cancel')" direction="left" />
    </a>
    <a @click="goNewProject" class="d-flex">
      <itt-arrow-btn :text="$t('buttons.next')" direction="right" />
    </a>
  </div>
</div>
</template>
<script>
import close from "../../components/icons/close.vue";
import imgAndSelect from "@/components/img-and-select";
import ittArrowBtn from "../../components/icons/arrow-btn";// @/components/icons/arrow-btn";
export default {
  components: {
    close,
    imgAndSelect,
    ittArrowBtn
  },
  data() {
    return {
      project: null,
      mountedPage: false
    };
  },
  computed: {
    getImages: function() {
      return this.$store.getters["image/getPreviews"];
    }
  },
  asyncComputed: {
    async getMedias() {
      let medias = await this.$store.getters["image/getPreviews"];
      medias = medias.map((img, index) => new Promise((resolve) => {
        let reader = new FileReader();
        reader.onload = e => {
          img.file_url = img.src;
          resolve(img);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(img);
      }));
      medias = await Promise.all(medias);
      return medias;
    }
  },
  methods: {
    deleteImg(img) {
      let index = this.getImages.indexOf(img);
      this.$store.dispatch("image/deleteOneMediaPreview", index);
    },
    goNewProject() {
      let images = this.$store.getters["image/getPreviews"];
        if (images.length == 0) {
          this.$store.commit('dialogModal/toggleNotif', [this.$t('titles.noImage'), this.$t('texts.addAndRetry')]);
          return;
        }
        this.$router.push("/newproject");
    },
    cancelImg() {
      this.$router.push("/");
      this.$store.dispatch("image/initPreviews");
    }
  },
  mounted() {
    setTimeout(() => this.mountedPage = true, 100);
  }
};
</script>
<style lang="sass" scoped>
.content-preview 
  padding-bottom: 30px
</style>
